import React, { useContext } from 'react';
import { WindowSizeContext } from '/src/App';
import './style.css';
import CreateCloudfrontUrl from '/src/services/CreateCloudfrontUrl';

const LTVAttractivenessAbout = ({
    currentStageData,
    incomePercentages
}) => {
    const { deviceType } = useContext(WindowSizeContext);
    const firstSentence = "The future value of this home will come down to the number of potential buyers and their willingness + ability to pay. Inherently, the larger the pool of potential buyers, the more likely it is that the home’s value will, at minimum be maintained, and hopefully grow. That's what competition does!"

    const secondSentence = "For prospective buyers, the affordability of this home comes down to more than just about the mortgage. When the costs of recurring expenses grow too quickly (thanks climate change!), that leaves less money for the mortgage itself, meaning buyers are forced to either stretch themselves or leave the buyer pool - lowering competition, and potentially hurting home value."

    const thirdSentence = "So what do we need to look for? We need to check is whether household incomes in this area are going to rise fast enough to accommodate the growing ownership costs of this home. If we see too larger of a gap, that could mean fewer buyers are able to afford this home, shrinking your buyer pool and potentially hurting the home’s value.  "

    const howMuchIncomeIsSpentOnHousingText = "How much of household income is spent on housing, inclusive of mortgage and things like insurance, maintenance and taxes"

    return (
        <div className="ltv-attractiveness-content">
            <h2 className="ltv-attractiveness-title">{currentStageData.title}</h2>
            <div className="ltv-attractiveness-icon">
                <img
                    src={CreateCloudfrontUrl('home-for-sale-icon-green.png')}
                    alt="Home for sale"
                />
            </div>
            <p className="ltv-attractiveness-description text-align-center" dangerouslySetInnerHTML={{ __html: firstSentence }} />
            <div className={`ltv-attractiveness-explanation ${deviceType}`}>
                <span className="ltv-attractiveness-headline text-align-center">
                    {howMuchIncomeIsSpentOnHousingText}
                </span>
                <div className="ltv-attractiveness-percentage-grid">
                    {incomePercentages.map(({ icon: Icon, percentage, level }) => (
                        <div key={percentage} className={`ltv-attractiveness-percentage-item ${level}`}>
                            <Icon className="ltv-attractiveness-icon" />
                            <span className="ltv-attractiveness-percentage">{percentage}</span>
                        </div>
                    ))}
                </div>
            </div>
            <p className="ltv-attractiveness-description text-align-center" dangerouslySetInnerHTML={{ __html: secondSentence }} />
        </div>
    );
};

export default LTVAttractivenessAbout;